import { useQuery } from "@tanstack/react-query";
import { getEventsListing } from "../../services/search";
import { useTranslation } from "react-i18next";
import { City } from "../../../types";

type Country = {
  cities: City[];
  code: string;
  id: number;
  name: string;
  nationality: string;
  shortCode: string;
  url: string;
  xCoord: number;
  yCoord: number;
};

type EventsListingParams = {
  page: number;
  tabValue: number;
  country: Country | null;
  city: City | null;
  status?: string | null;
  type?: string | null;
  minDate?: string;
  maxDate?: string;
};

const LIMIT = 5;

export const useEventsListing = ({
  page,
  tabValue,
  country,
  city,
  status,
  type,
  minDate,
  maxDate,
}: EventsListingParams) => {
  const { i18n } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: ["EventsList", i18n.language, tabValue, page, minDate, maxDate, country, city, status, type],
    queryFn: () => getEventsListing(page, LIMIT, country?.id, city?.id, status, type, minDate, maxDate, tabValue === 1),
  });

  const eventsListing = data?.items.map((post: any) => post.event) || [];
  const paginationData = data?.meta || {
    currentPage: 0,
    itemCount: 0,
    itemsPerPage: 0,
    totalItems: 0,
    totalPages: 0,
  };

  return { eventsListingResult: data, eventsListing, paginationData, isEventsListingResultLoading: isLoading };
};
